import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const DATOS_OBTENIDOS = 'DATOS_OBTENIDOS'
const OBTENIENDO_DATOS = 'OBTENIENDO_DATOS'
const SIZE_PRINTING = 'SIZE_PRINTING'

export default new Vuex.Store({
  state: {
    datosObtenidos: null,
    sizePrinting: null
  },
  mutations: {
    DATOS_OBTENIDOS (state, datos) {
      state.datosObtenidos = datos
    },
    OBTENIENDO_DATOS (state) {
      state.datosObtenidos = null
    },
    SIZE_PRINTING (state, datos) {
      state.sizePrinting = datos
    }
  },
  actions: {
    datosObtenidos ({ commit }, datos) {
      commit(DATOS_OBTENIDOS, datos)
    },
    obteniendoDatos ({ commit }) {
      commit(OBTENIENDO_DATOS)
    },
    changeSizePrinting ({ commit }, datos) {
      commit(SIZE_PRINTING, datos)
    }
  },
  getters: {
    currentData (state) {
      return state.datosObtenidos
    },
    currentSizePrinting (state) {
      return state.sizePrinting
    }
  }
})
